export default [
    {
        path: '/login',
        name: 'auth-login',
        component: () => import('@/views/pages/authentication/Login.vue'),
        meta:{
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        }
    },
    {
        path: '/pages/not-authorized',
        name: 'not-authorized',
        // ! Update import path
        component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
        meta: {
          layout: 'full',
          action: 'read',
          resource: 'Auth',
        },
      },
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/store/stores-list/StoresList.vue'),
        meta: {
          action: 'read',
          resource: 'Auth',
        }
        /*
        meta: {
          pageTitle: 'Home',
          
          breadcrumb: [
            {
              text: 'Home',
              active: true,
            },
          ],
          
        },
        */
      },
      {
        path: '/users/list',
        name: 'users-list',
        component: () => import('@/views/user/users-list/UsersList.vue'),
        meta:{
          action: 'read',
          resource: 'Auth',
        }
      },
      {
        path: '/second-page',
        name: 'second-page',
        component: () => import('@/views/SecondPage.vue'),
        meta: {
          pageTitle: 'Second Page',
          breadcrumb: [
            {
              text: 'Second Page',
              active: true,
            },
          ],
        },
      },
      /*
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login.vue'),
        meta: {
          layout: 'full',
        },
      },
      */
      {
        path: '/error-404',
        name: 'error-404',
        component: () => import('@/views/error/Error404.vue'),
        meta: {
          layout: 'full',
        },
      },


]